import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { generalClient, serviceOrdersClient } from '../../../apollo/api'

const MUTATION = gql`
  mutation RemoveTag($id: Int!) {
    removeTag(id: $id)
  }
`

export const useRemoveTag = () => {
  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['Tags'],
    client: generalClient,
    // `removeTag` roda no `generalClient`; as atividades que usavam essa tag (o back-elixir
    // zera o `tag_id` delas ao remover a tag) ficam em queries `ServiceOrders`/`ServiceOrder`
    // executadas pelo `serviceOrdersClient` — um client Apollo diferente. `refetchQueries` do
    // `useMutation` só alcança queries ativas do MESMO client, então um `refetchQueries: [...]`
    // aqui para essas queries seria um no-op silencioso (mesma pegadinha de cross-client já
    // documentada no projeto). Por isso refetch é disparado manualmente no client certo, igual
    // ao padrão já usado em `editStatus/_requests/saveEvents.js` para o mesmo tipo de caso.
    onCompleted: () => {
      serviceOrdersClient.refetchQueries({ include: ['ServiceOrders', 'ServiceOrder', 'ServiceOrdersCount'] })
    }
  })
  const notify = useNotification()
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = id => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: t('errorDelete') })
      }
    })
  }

  return [handleRequest, state]
}
